export default "/fcbcac1db17390110677298f9d30eeed9c121039/d50cc34e778c6c20c755dccf4a153599.svg";